import React, { useState, useEffect } from 'react'
import {
    Box,
    Typography,
    Card,
    CardContent,
    CardMedia,
    Button,
    Grid,
    Chip,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    useTheme,
    useMediaQuery,
    CircularProgress,
    Alert,
    Divider,
    Container,
    Paper,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Switch,
    FormControlLabel,
    Tabs,
    Tab,
    Modal,

} from '@mui/material';
import {
    Add,
    Edit,
    Delete,
    TableRestaurant,
    People,
    CheckCircle,
    Cancel,
    AccessTime,
    Image,
    Link,
    QrCode,
    ContentCopy,
    OpenInNew,
    Event,
    Person,
    Phone,
    Email,
    Visibility,
    Update,
    Download,
    Store
} from '@mui/icons-material';
import Rating from '@mui/material/Rating';
import { get_all_users } from '../services/profileService';
import { useNotification } from '../contexts/NotificationContext';
import CommonModal from '../components/common/CommonModal';
import { get_user,get_user_for_admin } from '../services/profileService'



const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    textAlign: "center"
};

const UserManagement = () => {
    const { showSuccess, showError } = useNotification();

    const [userData, setUserData] = useState([])
    const [modalFields, setModalFields] = useState([
        { 'id': 1, 'label': 'Title' },
        { 'id': 2, 'label': 'Description' },
        { 'id': 3, 'label': 'Customer Name' },
    ])
    const [modalFieldsData, setModalFieldsData] = useState({
        "title": "",
        "description": "",
        "customer_name": "",
        "stars": 0,
    })
    const [modalOpen, setModalOpen] = useState({ type: 'create', value: false })
    const [userViewId, setUserViewId] = useState(0)
    const [userModal, setUserModal] = useState(false)


    useEffect(() => {
        fetchUsers();
    }, []);


    const fetchUsers = async () => {
        try {
            const response = await get_all_users();
            setUserData(response.result);
        } catch (error) {
            console.error("Error fetching testimonials =>", error);
        }
    }



    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));


    return (

        <Box>
            <Box sx={{
                mb: { xs: 3, sm: 4 },
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row' },
                justifyContent: 'space-between',
                alignItems: { xs: 'flex-start', sm: 'center' },
                gap: { xs: 2, sm: 0 }
            }}>
                <Box>
                    <Typography
                        variant={isMobile ? "h5" : "h4"}
                        fontWeight="bold"
                        gutterBottom
                    >
                        User Management
                    </Typography>
                    <Typography variant="body1" color="text.secondary">
                        Manage User Details
                    </Typography>
                </Box>
            </Box>
            {userData.length === 0 &&
                <Card sx={{
                    p: 3,
                    pb:2,
                    textAlign: 'center',
                    bgcolor: '#fff',
                    boxShadow: 1
                }}>
                    <CardContent>
                        <Typography variant="h6" color="text.secondary">
                            No User Available
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                            Add new users to get started
                        </Typography>
                    </CardContent>
                </Card>
            }
            {userData.length > 0 &&

                <><Card>
                    <TableContainer
                        component={Paper}
                        elevation={0}
                        sx={{
                            overflowX: 'auto',
                            '&::-webkit-scrollbar': {
                                height: '8px',
                            },
                            '&::-webkit-scrollbar-track': {
                                backgroundColor: 'rgba(0,0,0,0.1)',
                                borderRadius: '4px',
                            },
                            '&::-webkit-scrollbar-thumb': {
                                backgroundColor: 'rgba(0,0,0,0.3)',
                                borderRadius: '4px',
                            },
                        }}
                    >
                        <Table sx={{ minWidth: 600 }}>
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{
                                        fontSize: { xs: '0.75rem', sm: '0.875rem' },
                                        fontWeight: 600,
                                        minWidth: { xs: '100px', sm: '120px' },
                                        whiteSpace: 'nowrap'
                                    }}>
                                        S.No
                                    </TableCell>
                                    <TableCell sx={{
                                        fontSize: { xs: '0.75rem', sm: '0.875rem' },
                                        fontWeight: 600,
                                        minWidth: { xs: '80px', sm: '100px' },
                                        whiteSpace: 'nowrap'
                                    }}>
                                        Name
                                    </TableCell>
                                    <TableCell sx={{
                                        fontSize: { xs: '0.75rem', sm: '0.875rem' },
                                        fontWeight: 600,
                                        minWidth: { xs: '120px', sm: '150px' },
                                        whiteSpace: 'nowrap',
                                        display: { xs: 'none', md: 'table-cell' }
                                    }}>
                                        Email
                                    </TableCell>
                                    <TableCell sx={{
                                        fontSize: { xs: '0.75rem', sm: '0.875rem' },
                                        fontWeight: 600,
                                        minWidth: { xs: '120px', sm: '150px' },
                                        whiteSpace: 'nowrap'
                                    }}>
                                        Phone
                                    </TableCell>
                                    <TableCell sx={{
                                        fontSize: { xs: '0.75rem', sm: '0.875rem' },
                                        fontWeight: 600,
                                        minWidth: { xs: '100px', sm: '120px' },
                                        whiteSpace: 'nowrap'
                                    }}>
                                        Action
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {userData.map((items, index) => (
                                    <TableRow hover>
                                        <TableCell sx={{
                                            fontSize: { xs: '0.75rem', sm: '0.875rem' },
                                            whiteSpace: 'nowrap'
                                        }}>
                                            <Typography variant="body2" fontWeight="bold" sx={{
                                                fontSize: { xs: '0.75rem', sm: '0.875rem' },
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap'
                                            }}>
                                                {index + 1}
                                            </Typography>
                                        </TableCell>
                                        <TableCell sx={{
                                            fontSize: { xs: '0.75rem', sm: '0.875rem' },
                                            whiteSpace: 'nowrap'
                                        }}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                <Typography variant="body2" sx={{
                                                    fontSize: { xs: '0.75rem', sm: '0.875rem' },
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap'
                                                }}>
                                                    {items.name}
                                                </Typography>
                                            </Box>
                                        </TableCell>
                                        <TableCell sx={{
                                            fontSize: { xs: '0.75rem', sm: '0.875rem' },
                                            whiteSpace: 'nowrap',
                                            display: { xs: 'none', md: 'table-cell' }
                                        }}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                <Typography variant="body2" sx={{
                                                    fontSize: { xs: '0.75rem', sm: '0.875rem' },
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap'
                                                }}>

                                                    {items.email}
                                                </Typography>
                                            </Box>
                                        </TableCell>
                                        <TableCell sx={{
                                            fontSize: { xs: '0.75rem', sm: '0.875rem' },
                                            whiteSpace: 'nowrap'
                                        }}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                <Typography variant="body2" sx={{
                                                    fontSize: { xs: '0.75rem', sm: '0.875rem' },
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap'
                                                }}>
                                                    {items?.phone ? items.phone : " - "}
                                                </Typography>
                                            </Box>
                                        </TableCell>
                                        {/* <TableCell sx={{
                                        fontSize: { xs: '0.75rem', sm: '0.875rem' },
                                        whiteSpace: 'nowrap'
                                    }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <Phone sx={{
                                                fontSize: { xs: 14, sm: 16 },
                                                color: 'text.secondary'
                                            }} />
                                            <Typography variant="body2" sx={{
                                                fontSize: { xs: '0.75rem', sm: '0.875rem' },
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap'
                                            }}>
                                                {order.customer_phone}
                                            </Typography>
                                        </Box>
                                    </TableCell> */}
                                        {/* <TableCell sx={{
                                        fontSize: { xs: '0.75rem', sm: '0.875rem' },
                                        whiteSpace: 'nowrap'
                                    }}>
                                        <Chip
                                            // label={getStatusLabel(order.status)}
                                            // color={getStatusColor(order.status)}
                                            size="small"
                                            sx={{
                                                fontSize: { xs: '0.7rem', sm: '0.75rem' },
                                                height: { xs: '20px', sm: '24px' }
                                            }}
                                        />
                                    </TableCell> */}
                                        {/* <TableCell sx={{
                                        fontSize: { xs: '0.75rem', sm: '0.875rem' },
                                        whiteSpace: 'nowrap',
                                        display: { xs: 'none', sm: 'table-cell' }
                                    }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <AccessTime sx={{
                                                fontSize: { xs: 14, sm: 16 },
                                                color: 'text.secondary'
                                            }} />
                                            <Typography variant="body2" sx={{
                                                fontSize: { xs: '0.75rem', sm: '0.875rem' },
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap'
                                            }}>
                                                {formatDate(order.created_at)}
                                            </Typography>
                                        </Box>
                                    </TableCell> */}
                                        <TableCell sx={{
                                            fontSize: { xs: '0.75rem', sm: '0.875rem' },
                                            whiteSpace: 'nowrap'
                                        }}>
                                            <Box sx={{
                                                display: 'flex',
                                                gap: { xs: 0.5, sm: 1 },
                                                flexWrap: 'nowrap'
                                            }}>
                                                <IconButton
                                                    size="small"
                                                    color="secondary"
                                                    sx={{
                                                        minWidth: { xs: '32px', sm: '40px' },
                                                        height: { xs: '32px', sm: '40px' }
                                                    }}
                                                    onClick={() => {
                                                        // console.log("Item => ", items)
                                                        setUserViewId(items.id)
                                                        setUserModal(true)
                                                    }}
                                                >
                                                    <Visibility sx={{ fontSize: { xs: 16, sm: 20 } }} />
                                                </IconButton>
                                                {/* <IconButton
                                                size="small"
                                                // onClick={() => handleDownloadInvoice(order)}
                                                color="success"
                                                sx={{
                                                    minWidth: { xs: '32px', sm: '40px' },
                                                    height: { xs: '32px', sm: '40px' }
                                                }}
                                                title="Download Kitchen Invoice"
                                            >
                                                <Download sx={{ fontSize: { xs: 16, sm: 20 } }} />
                                            </IconButton> */}
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Card>

                    <CommonModal
                        modalOpen={userModal}
                        setModalOpen={setUserModal}
                        children={<ViewUserDetails userViewId={userViewId} />}
                    />
                </>
            }


        </Box>
    )
}


const ViewUserDetails = ({ userViewId }) => {

    const [details, setDetails] = useState({})
    const { showSuccess, showError } = useNotification()

    useEffect(() => {
        async function fetchUserDetail() {
            try {
                const response = await get_user_for_admin(userViewId)
                setDetails(response)
            }
            catch (error) {
                showError(error.message)
            }
        }
        fetchUserDetail()
    }, [])
    // console.log("Details => ", details);

    return (
        <Box sx={{ p: 3, maxWidth: 400, margin: '0 auto' }}>
            {/* Header */}
            <Typography
                variant="h5"
                sx={{
                    fontWeight: 600,
                    color: 'primary.main',
                    textAlign: 'center',
                    mb: 3,
                    pb: 2,
                    borderBottom: '2px solid',
                    borderColor: 'divider'
                }}
            >
                User Details
            </Typography>

            {/* User Details Container */}
            <Box sx={{
                backgroundColor: 'grey.50',
                borderRadius: 2,
                p: 3,
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
            }}>
                {/* Username */}
                <Box sx={{ mb: 2.5 }}>
                    <Typography
                        variant="caption"
                        sx={{
                            fontWeight: 600,
                            color: 'text.secondary',
                            textTransform: 'uppercase',
                            fontSize: '0.75rem',
                            letterSpacing: 0.5
                        }}
                    >
                        Username
                    </Typography>
                    <Typography
                        sx={{
                            fontWeight: 500,
                            fontSize: '1.1rem',
                            color: 'text.primary'
                        }}
                    >
                        {details?.username || 'Not provided'}
                    </Typography>
                </Box>

                {/* Email */}
                <Box sx={{ mb: 2.5 }}>
                    <Typography
                        variant="caption"
                        sx={{
                            fontWeight: 600,
                            color: 'text.secondary',
                            textTransform: 'uppercase',
                            fontSize: '0.75rem',
                            letterSpacing: 0.5
                        }}
                    >
                        Email Address
                    </Typography>
                    <Typography
                        sx={{
                            fontWeight: 500,
                            color: 'text.primary',
                            wordBreak: 'break-word'
                        }}
                    >
                        {details?.email || 'Not provided'}
                    </Typography>
                </Box>

                {/* Phone */}
                <Box sx={{ mb: 2.5 }}>
                    <Typography
                        variant="caption"
                        sx={{
                            fontWeight: 600,
                            color: 'text.secondary',
                            textTransform: 'uppercase',
                            fontSize: '0.75rem',
                            letterSpacing: 0.5
                        }}
                    >
                        Phone Number
                    </Typography>
                    <Typography
                        sx={{
                            fontWeight: 500,
                            color: 'text.primary'
                        }}
                    >
                        {details?.phone || 'Not provided'}
                    </Typography>
                </Box>

                {/* Created At */}
                <Box>
                    <Typography
                        variant="caption"
                        sx={{
                            fontWeight: 600,
                            color: 'text.secondary',
                            textTransform: 'uppercase',
                            fontSize: '0.75rem',
                            letterSpacing: 0.5
                        }}
                    >
                        Member Since
                    </Typography>
                    <Typography
                        sx={{
                            fontWeight: 500,
                            color: 'text.primary'
                        }}
                    >
                        {details?.created_at ? new Date(details.created_at).toLocaleDateString('en-US', {
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric'
                        }) : 'Not available'}
                    </Typography>
                </Box>
            </Box>
        </Box>
    )
}

export default UserManagement;